import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useProcessAuth } from '~/hooks';
import Layout from '~/pages/ProcessPortal/Layout';

const AdmissaoRoute = ({ component: Component, path, ...rest }) => {
  const { isLogged } = useProcessAuth();

  // Se não está logado e não está na página de signin, redireciona para signin
  if (path !== '/admissao/signin' && !isLogged()) {
    return <Redirect to="/admissao/signin" />;
  }

  // Se está logado e está na página de signin, redireciona para a listagem
  if (path === '/admissao/signin' && isLogged()) {
    return <Redirect to="/admissao" />;
  }

  return (
    <Route
      {...rest}
      render={props => (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default AdmissaoRoute;
